module.exports = __webpack_public_path__ + "img/illustrationEmail.330a3e43.png";